// ============================================================================
// SPANISH TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Colección de versículos inspiradores con referencias Strong

export const bibleVerses = [
  {
    reference: "Filipenses 4:13",
    text: "Todo lo puedo en Cristo que me fortalece",
    version: "RVR1960",
    theme: "fuerza",
    strongNumbers: {
      "puedo": "G1411", // δύναμις (dynamis) = poder, fuerza
      "fortalece": "G1743" // ἐνδυναμόω (endynamoo) = fortalecer
    },
    context: "Pablo habla de su capacidad para enfrentar todas las situaciones gracias a Cristo"
  },
  {
    reference: "Salmo 23:1",
    text: "Jehová es mi pastor; nada me faltará",
    version: "RVR1960",
    theme: "protección",
    strongNumbers: {
      "pastor": "H7462", // רָעָה (ra'ah) = pastorear, cuidar
      "faltará": "H2637" // חָסֵר (chaser) = faltar, necesitar
    },
    context: "David expresa su confianza total en la providencia divina"
  },
  {
    reference: "Juan 3:16",
    text: "Porque de tal manera amó Dios al mundo, que ha dado a su Hijo unigénito",
    version: "RVR1960",
    theme: "amor",
    strongNumbers: {
      "amó": "G25", // ἀγαπάω (agapao) = amar incondicionalmente
      "dado": "G1325" // δίδωμι (didomi) = dar, ofrecer
    },
    context: "El versículo más célebre sobre el amor de Dios por la humanidad"
  },
  {
    reference: "Filipenses 4:7",
    text: "Y la paz de Dios, que sobrepasa todo entendimiento, guardará vuestros corazones",
    version: "RVR1960",
    theme: "paz",
    strongNumbers: {
      "paz": "G1515", // εἰρήνη (eirene) = paz, armonía
      "guardará": "G5432" // φρουρέω (phroureo) = guardar, proteger
    },
    context: "Promesa de protección divina mediante la paz interior"
  },
  {
    reference: "Salmo 119:105",
    text: "Lámpara es a mis pies tu palabra, y lumbrera a mi camino",
    version: "RVR1960",
    theme: "guía",
    strongNumbers: {
      "lámpara": "H5216", // נִיר (niyr) = lámpara, luminaria
      "lumbrera": "H216" // אוֹר (or) = luz, iluminación
    },
    context: "La Palabra de Dios como guía en la vida cotidiana"
  },
  {
    reference: "Proverbios 3:5-6",
    text: "Fíate de Jehová de todo tu corazón, y no te apoyes en tu propia prudencia",
    version: "RVR1960",
    theme: "confianza",
    strongNumbers: {
      "fíate": "H982", // בָּטַח (batach) = confiar
      "corazón": "H3820" // לֵב (leb) = corazón, mente, voluntad
    },
    context: "Invitación a confiar en Dios en lugar de nuestras propias capacidades"
  },
  {
    reference: "Mateo 5:14",
    text: "Vosotros sois la luz del mundo; una ciudad asentada sobre un monte no se puede esconder",
    version: "RVR1960",
    theme: "testimonio",
    strongNumbers: {
      "luz": "G5457", // φῶς (phos) = luz, iluminación espiritual
      "mundo": "G2889" // κόσμος (kosmos) = mundo, universo
    },
    context: "Jesús anima a sus discípulos a ser testigos en el mundo"
  }
];

export default bibleVerses;
